/**
 * Created by wangjun on 2018/1/26.
 *
 * Update by zero on 2018/09/19
 */
export const SUCCESSCODE = 200000;

/* form 布局大小 */
export const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
  colon: true,
};

/* popup form 布局大小 */
export const popupFormItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
  colon: true,
};

export const formItemLayout2 = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const formItemLayout3 = {
  labelCol: { span: 9 },
  wrapperCol: { span: 15 },
};

const toolbarHide = {
  show: false,
};
const toobbarShow = {
  show: true,
  size: 'large',
};

export const imgOptions = {
  title: false, //图片名称
  navbar: false, //缩略图
  fullscreen: false, //全屏播放
  loop: false, //是否循环 上一个 下一个
  loading: false,
  button: true, //
  tooltip: true, //缩放百分比
  movable: true, //图片移动
  toolbar: {
    zoomIn: toobbarShow, //放大
    zoomOut: toobbarShow, //缩小
    oneToOne: toolbarHide, //自适应
    reset: toobbarShow, //重置
    prev: toobbarShow, //上一张
    play: toolbarHide, //播放
    next: toobbarShow, //下一张
    rotateLeft: toolbarHide, //左旋转
    rotateRight: toolbarHide, //右旋转
    flipHorizontal: toolbarHide, //左右翻转
    flipVertical: toolbarHide, //上下翻转
  },
};

export const auditStatusList = [
  { key: '0', value: '发票未录入' },
  { key: '1', value: '发票已录入未审核' },
  { key: '2', value: '票核通过' },
  { key: '3', value: '票核拒绝' },
  { key: '5', value: '初审中' },
  { key: '6', value: '初审通过' },
  { key: '7', value: '初审不通过' },
];

/* AM、PM */
export const AMPM = [
  { key: 'AM', value: 'AM' },
  { key: 'PM', value: 'PM' },
];
// 地图排线状态
export const mapRouteStatusList = [
  { key: 0, value: '待排线' },
  { key: 1, value: '排线中' },
  { key: 3, value: '排线完成' },
  { key: 4, value: '需取消排线' },
];